import { Storage } from "./storage";

const TOKEN_KEY = "tg_token";

export async function getToken() {
  return Storage.get(TOKEN_KEY, "");
}

export async function saveToken(token) {
  await Storage.set(TOKEN_KEY, token);
}

export async function bearer() {
  const token = await getToken();
  return token ? `Bearer ${token}` : null;
}

export async function clearSession() {
  await Storage.remove(TOKEN_KEY);
  await Storage.remove("tg_profile_cache");
}
